import React, { useState } from 'react';
import { KTSVG } from '../../../../_metronic/helpers';
import { deleteCompanyGroupAdmin } from '../core/_requests';
import { toast } from 'react-toastify';
import { showErrorToast } from '../../../shared/utils/apiErrorMessage';

interface Props {
    isOpen: boolean;
    onClose: () => void;
    companyAdminData: any;
    onCompanyDeleted: () => void;
}

const DeleteCompanyAdminModal: React.FC<Props> = ({ onClose, isOpen, companyAdminData, onCompanyDeleted }) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const handleDeleteCompany = async () => {
        if (!companyAdminData?.id || loading) return;
        setLoading(true);
        setError(null);
        try {
            await deleteCompanyGroupAdmin(companyAdminData.id);
            toast.success("Company deleted successfully");
            onCompanyDeleted();
            onClose();
        } catch (err) {
            console.error('Failed to delete company:', err);
            const msg = showErrorToast(err, 'Failed to delete company. It may have associated records.', 'delete');
            setError(msg);
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ paddingInline: '1rem', maxWidth: '30rem' }}>
                <div className="custom-modal-header border-0 d-flex justify-content-end align-items-center">
                    <button className="close-btn" onClick={onClose} disabled={loading}>
                        <KTSVG path='/media/map/x.svg' className='svg-icon-2x' />
                    </button>
                </div>

                <div className="custom-modal-body pt-0">
                    <div className="d-flex justify-content-center mb-4">
                        <KTSVG path='/media/map/exclamation.svg' className='svg-icon-4x'></KTSVG>
                    </div>
                    {error && (
                        <div className="alert alert-danger py-2 px-3 text-center mb-3 fs-7">
                            {error}
                        </div>
                    )}
                    <p className="text-center">
                        Are you sure you want to delete <strong>{companyAdminData?.name || 'this company'}</strong>?<br />
                        <strong>All the data under this company will be permanently deleted.</strong>
                    </p>
                    <div className="d-flex justify-content-center gap-2 mt-5">
                        <button className="btn btn_secondary" onClick={onClose} disabled={loading}>
                            No, Keep it
                        </button>
                        <button className="btn btn_danger d-flex align-items-center gap-2" onClick={handleDeleteCompany} disabled={loading}>
                            {loading && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />}
                            {loading ? 'Deleting...' : 'Yes, Delete!'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeleteCompanyAdminModal;
